import i18next from '@/i18n/config';
import { store } from '@/store';
import GlobalStyle from '@/theme/global-style';
import { theme } from '@/theme/theme';
import { useLocation } from '@reach/router';
import 'bootstrap-icons/font/bootstrap-icons.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Script } from 'gatsby';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import styled, { ThemeProvider } from 'styled-components';

import { GlobalIOSButtonFix } from '@/components/common/GlobalIOSButtonFix';
import LiveChatBox from '@/components/common/LiveChatBox';
import Header from '@/components/layout/Header';
import { PROD_GTM, UAT_GTM, UAT_HOST } from '@/constants';
import { useWindowSize } from '@/hook';
import { getOrigin, getRoute } from '@/hooks/useRouteSection';

const Layout = (props: any) => {
  const location = useLocation();
  const routePage = getRoute(location.pathname).page;
  const pathname = (location?.pathname ?? '').toLowerCase();

  const isLargeScreen = useWindowSize();

  const isPaymentStatusPage = /\/payment\/(success|failed)\/?$/.test(pathname);

  const shouldHideMobileHeader =
    !isLargeScreen &&
    ['plan', 'application', 'review', 'payment'].includes(routePage) &&
    !isPaymentStatusPage;

  const origin = getOrigin() || '';
  const lowerOrigin = origin.toLowerCase();
  const isNonProd =
    lowerOrigin.includes(UAT_HOST.toLowerCase()) ||
    lowerOrigin.includes('localhost');
  const GTMCode = isNonProd ? UAT_GTM : PROD_GTM;

  return (
    <Provider store={store}>
      <Script id="first-unique-id">
        {`
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','GTM-${GTMCode}');
            `}
      </Script>
      <GlobalStyle />
      <GlobalIOSButtonFix />
      <ThemeProvider theme={theme}>
        <div className={shouldHideMobileHeader ? 'd-none d-md-block' : ''}>
          <Header />
        </div>
        <Styles>
          <I18nextProvider i18n={i18next}>{props.children}</I18nextProvider>
        </Styles>
        {/* {<Footer />} */}
        <LiveChatBox />
      </ThemeProvider>
    </Provider>
  );
};

export default Layout;

const Styles = styled.div`
  margin: 0px auto;
  padding-top: 0px;
  min-height: calc(100vh - 10rem);
  background: #fff bottom no-repeat;
`;
